<div class="modal common-right-modal d-block" id="AddProvider" aria-hidden="true" aria-labelledby="exampleModalToggleLabel"
    tabindex="-1" style="display: block;" role="dialog" [ngClass]="{'show':showSlider}">
    <div class="modal-dialog modal-large">
        <div class="modal-content">
            <div class="modal-header ">
                <div class="title-head d-flex align-items-center">
                    <button id="btnAddGroupClose" type="button" class="btn-close tool-wrap position-relative" data-bs-dismiss="modal"
                    (click)="closeBtn()" aria-label="Close">
                    <div class="custom-tooltip tooltip-top" role="tooltip">
                        <div class="arrow"></div>
                        <div class="tooltip-inner"> Close </div>
                      </div></button>
                    <h2 class="modal-title" id="exampleModalToggleLabel">{{pageHead}}</h2>
                </div>
                <div class="btn-wrap">

                    <button id="btnproCancel" type="button" class="btn btn-outline-secondary"
                        (click)="closeBtn()">Cancel</button>
                    <button id="btnproSave" type="button" class="btn btn-primary" [disabled]="showDetails || isLoader" (click)="saveForm()">Save</button>
                </div>
            </div>
            <div class="inner-loader-wraper" *ngIf="isLoader">
                <div class="inner-loader"></div>
            </div>
            <div class="modal-body insurance-modal" *ngIf="!isLoader ">
                <div class="accordion">
                    <ng-container  [formGroup]="provMngmtForm">
                    <app-prov-regulator [isEdit]='isEdit' formGroupName="regulatorForm" [submitted]="submitted"></app-prov-regulator>
                    <app-prov-details [isEdit]='isEdit' formGroupName="provDetailsForm" [submitted]="submitted"  ></app-prov-details>
                    <app-company-address formGroupName="addressForm" [submitted]="submitted" [states]="stateList" [city]="cityList">
                    </app-company-address>
                    <app-prov-contact formGroupName="contactForm" [isEdit]='isEdit' [formSubmitted]="submitted" [userIdExists]="userIdExists"></app-prov-contact>
                    <app-credentials [isEdit]='isEdit' formGroupName="credentialsForm" [submitted]="submitted">
                    </app-credentials>
                </ng-container>
                </div>
            </div>
            
        </div>
       
    </div>
    
</div>
